import GuestVisitorsConfirm from './GuestVisitorsConfirm';

export default GuestVisitorsConfirm;
